import React, { forwardRef, LegacyRef } from 'react'

import styles from '../style.module.less'
import { BaseIconProps } from '../types'

export const YonghuTianjia = forwardRef(
  (
    { _width, _height, _fill, className, spin, rtl, ...rest }: BaseIconProps,
    root: LegacyRef<SVGSVGElement>
  ) => {
    return (
      <svg
        ref={root}
        width={_width}
        height={_height}
        viewBox="0 0 48 48"
        preserveAspectRatio="xMidYMid meet"
        fill="none"
        role="presentation"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ''} ${spin ? styles.spin : ''} ${
          rtl ? styles.rtl : ''
        }`.trim()}
        {...rest}
      >
        <g>
          <defs>
            <clipPath id="bb460__a">
              <rect
                rx="0"
                height="48"
                width="48"
              />
            </clipPath>
          </defs>
          <g clipPath="url(#bb460__a)">
            <path
              fillRule="evenodd"
              d="M24 9a5 5 0 1 0 0 10 5 5 0 0 0 0-10Zm-9 5a9 9 0 1 1 18 0 9 9 0 0 1-18 0Zm2 15a8 8 0 0 0-8 8v2h16v4H5v-6c0-6.627 5.373-12 12-12h8v4h-8Zm17 4v-3.974c0-1.105.91-2.026 2.015-2.026C37.09 27 38 27.921 38 29.026V33h3.974c1.105 0 2.026.91 2.026 2.015C44 36.09 43.079 37 41.974 37H38v3.974C38 42.079 37.09 43 35.985 43 34.91 43 34 42.079 34 40.974V37h-3.974C28.921 37 28 36.09 28 34.985 28 33.91 28.921 33 30.026 33H34Z"
              data-follow-fill="#455766"
              fill={_fill}
            />
          </g>
        </g>
      </svg>
    )
  }
)
